import { useAtomValue, useSetAtom } from 'jotai';
import { FlaskConical } from 'lucide-react';

import { NavItem } from '@crossnokaye/ux-common';

import { labsAssignmentAtom, labsDialogOpenAtom } from './labs.state';

/**
 * "CrossnoKaye Labs" entry for the user profile menu. Opens the Labs dialog. Renders nothing unless
 * the user is targeted by the `gaia-prototype` flag or is on a Labs prototype.
 */
export const LabsMenuItem = () => {
  const { status } = useAtomValue(labsAssignmentAtom);
  const setDialogOpen = useSetAtom(labsDialogOpenAtom);

  if (status === 'none') return null;

  return (
    <NavItem
      id={'labs'}
      data-component={'LabsMenuItem'}
      data-testid={'labs-menu-item'}
      label={'CrossnoKaye Labs'}
      icon={<FlaskConical className="glyph glyph-sm" aria-hidden="true" />}
      className={'hover:bg-tertiary p-2'}
      onClick={() => setDialogOpen(true)}
    />
  );
};
